import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { DollarSign, TrendingUp, TrendingDown, RefreshCw } from 'lucide-react';

const Balance = ({ balance, profit = 0, onRefresh = null }) => {
  const { tt } = useLanguage();
  const isPositive = profit >= 0;
  
  // Enhanced NaN protection for balance display
  const safeBalance = (() => {
    if (balance === null || balance === undefined) return 0.00;
    const numBalance = parseFloat(balance);
    return isNaN(numBalance) ? 0.00 : numBalance;
  })();
  
  // Enhanced NaN protection for profit display
  const safeProfit = (() => {
    const numProfit = parseFloat(profit);
    return isNaN(numProfit) ? 0.00 : numProfit;
  })();

  return (
    <div className="flex items-center space-x-2 md:space-x-4 bg-black/30 rounded-lg px-2 md:px-4 py-1.5 md:py-2">
      <div className="flex items-center space-x-1.5 md:space-x-2">
        <DollarSign className="w-4 h-4 md:w-5 md:h-5 text-blue-400" />
        <div>
          <div className="text-white font-mono text-sm md:text-lg">
            ${safeBalance.toFixed(2)}
          </div>
          <div className="text-gray-400 text-[10px] md:text-xs flex items-center space-x-1">
            <span className="hidden md:inline">{tt('Торговый счет')}</span>
            <span className="md:hidden">{tt('Счет')}</span>
            {onRefresh && (
              <button
                onClick={onRefresh}
                className="hover:text-blue-400 transition-colors"
                title={tt('Обновить баланс')}
              >
                <RefreshCw className="w-3 h-3" />
              </button>
            )}
          </div>
        </div>
      </div>
      
      {safeProfit !== 0 && (
        <div className={`flex items-center space-x-1 ${
          isPositive ? 'text-green-400' : 'text-red-400'
        }`}>
          {isPositive ? (
            <TrendingUp className="w-4 h-4" />
          ) : (
            <TrendingDown className="w-4 h-4" />
          )}
          <span className="font-mono text-sm">
            {isPositive ? '+' : ''}${safeProfit.toFixed(2)}
          </span>
        </div>
      )}
    </div>
  );
};

export default Balance;